(() => {
  const script = document.currentScript;
  const currentHandle = script?.dataset.productHandle;
  const storageKey = 'noxwell_recently_viewed_products_v1';

  if (!currentHandle) return;

  const readHistory = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
    } catch (error) {
      return [];
    }
  };

  const previousHandles = [...new Set(readHistory())].filter((handle) => handle !== currentHandle);

  try {
    localStorage.setItem(storageKey, JSON.stringify([currentHandle, ...previousHandles].slice(0, 12)));
  } catch (error) {
    return;
  }

  const renderRecentlyViewed = async () => {
    const sections = document.querySelectorAll('[data-recently-viewed-products]');
    if (!sections.length || !previousHandles.length) return;

    const root = window.Shopify?.routes?.root || '/';

    await Promise.all(
      [...sections].map(async (section) => {
        const grid = section.querySelector('[data-recently-viewed-grid]');
        const limit = Number(section.dataset.limit) || 4;
        if (!grid) return;

        const cards = await Promise.all(
          previousHandles.slice(0, limit).map(async (handle) => {
            try {
              const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=recently-viewed-product-card`);
              if (!response.ok) return null;

              const html = await response.text();
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              return documentFragment.querySelector('.recently-viewed-product-card');
            } catch (error) {
              return null;
            }
          })
        );

        cards.filter(Boolean).forEach((card) => grid.appendChild(card));
        if (grid.children.length) section.hidden = false;
      })
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecentlyViewed, { once: true });
  } else {
    renderRecentlyViewed();
  }
})();
